// EL ENLACE DE PAGO DE UN LEAD, PARA SU FICHA (10-10-2026).
//
// «Enlace de pago» (tarjeta «Piden que les llamemos») lo guardaba en `lead.enlace_pago` y lo
// copiaba al portapapeles, pero la ficha del lead no lo enseñaba: perdido el portapapeles,
// había que crear otro. Aquí se decide qué se enseña; la pantalla solo lo pinta.
//
//   - «enviado»: plan, importe, cuándo se creó y la dirección para volver a copiarla.
//   - «pagado»: lo mismo con lo que se cobró de verdad y cuándo, y SIN dirección (ya no hay
//     nada que mandar).
//   - sin enlace, o con un enlace sin dirección ni pago: null.
import { nombreDePlan } from './labels';
import { euros } from './precios';

export const enlaceDePagoDelLead = (lead, catalogo) => {
    const e = lead?.enlace_pago;
    if (!e || typeof e !== 'object') return null;
    const pagado = e.estado === 'pagado';
    if (!pagado && !e.url) return null;
    const importe = pagado ? (e.importe_pagado_eur ?? e.importe_eur) : e.importe_eur;
    return {
        estado: pagado ? 'pagado' : 'enviado',
        titulo: pagado ? 'Enlace de pago · pagado' : 'Enlace de pago · enviado, sin pagar',
        plan: nombreDePlan(e.plan, catalogo),
        importe: importe == null ? null : euros(importe),
        fecha: (pagado ? e.pagado_at : e.creado_at) || null,
        url: pagado ? null : e.url,
    };
};
